import { render, staticRenderFns } from "./VulnerabilityAssessmentIssueBody.vue?vue&type=template&id=08931600&scoped=true"
import script from "./VulnerabilityAssessmentIssueBody.vue?vue&type=script&lang=js"
export * from "./VulnerabilityAssessmentIssueBody.vue?vue&type=script&lang=js"
import style0 from "./VulnerabilityAssessmentIssueBody.vue?vue&type=style&index=0&id=08931600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08931600",
  null
  
)

export default component.exports